import React from 'react';
import {Control, ErrorComponent, Checkbox} from 'MWComponents';
import '../less';

export default function template() {
    const model = this.getModel(),
        {customerName, contactPhoneNumber, okpo, city, email, agree} = model.fields,
        isExpressEnergy = this.props.attribute === 'become a partner',
        form = (
            <>
                <div className="title-form">{this.l10n('PBP_ENTITY_MODAL_TITLE')}</div>
                <div className="send-form">
                  <div className="send-form__item">
                    <div className='send-form__item-title'>{this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_TITLE_3')}</div>
                    <input
                      type="text"
                      className={`custom-input ${
                        !city.isValid && !city.firstInput ? 'red-color' : ''
                      }`}
                      name="city"
                      value={city.value}
                      onChange={this.handleChange}
                      placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_6')}
                      maxLength={20}
                      autoComplete="off"
                    />
                  </div>
                  <div className="send-form__item">
                    <div className='send-form__item-title'>{this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_TITLE_2')}</div>
                    <input
                      type="text"
                      className={`custom-input ${
                        !okpo.isValid && !okpo.firstInput ? 'red-color' : ''
                      }`}
                      name="okpo"
                      value={okpo.value}
                      onChange={this.handleChange}
                      placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_2')}
                      onBlur={() => this.onBlurHandle('okpo')}
                      maxLength={100}
                      autoComplete="off"
                    />
                  </div>
                    <div className="send-form__item">
                      <div className='send-form__item-title'>{this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_TITLE_4')}</div>
                        <input
                            type="text"
                            className={`custom-input ${
                                !contactPhoneNumber.isValid && !contactPhoneNumber.firstInput
                                    ? 'red-color'
                                    : ''
                            }`}
                            name="contactPhoneNumber"
                            value={contactPhoneNumber.value}
                            onChange={this.handleChange}
                            placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_2')}
                            onBlur={() => this.onBlurHandle('contactPhoneNumber')}
                            maxLength={20}
                            autoComplete="off"
                        />
                    </div>
                </div>
              <div className="send-form__item">
                <div className='send-form__item-title'>{this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_TITLE_1')}</div>
                <input
                  type="text"
                  className={`custom-input ${
                    !customerName.isValid && !customerName.firstInput ? 'red-color' : ''
                  }`}
                  name="customerName"
                  value={customerName.value}
                  onChange={this.handleChange}
                  placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_7')}
                  onBlur={() => this.onBlurHandle('customerName')}
                  maxLength={100}
                  autoComplete="off"
                />
              </div>
              <div className="send-form__item">
                <div className='send-form__item-title'>{this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_TITLE_5')}</div>
                <input
                  type="text"
                  className={`custom-input ${
                    !email.isValid && !email.firstInput ? 'red-color' : ''
                  }`}
                  name="email"
                  value={email.value}
                  onChange={this.handleChange}
                  placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_8')}
                  onBlur={() => this.onBlurHandle('email')}
                  maxLength={100}
                  autoComplete="off"
                />
                {!isExpressEnergy && <div className="email-explanation-text">{this.l10n('BUSINESS_NEW_ORDER_EMAIL_EXPLANATION_TEXT')}</div>}
              </div>
              {!isExpressEnergy && <div className='star-explanation'>{this.l10n('BUSINESS_NEW_ORDER_MODAL_STAR_TEXT')}</div>}

                {/*<div className="i-agree-block">*/}
                {/*    <Checkbox*/}
                {/*        checked={agree.value}*/}
                {/*        onChange={e => this.selectItem('agree')}*/}
                {/*        className="checkbox-agree"*/}
                {/*    >*/}
                {/*        <span dangerouslySetInnerHTML={{__html: this.l10n('BUSINESS_NEW_ORDER_MODAL_AGREE_TEXT')}}></span>*/}
                {/*    </Checkbox>*/}
                {/*</div>*/}
                <div className="button-wrapper">
                    <button
                        className="button button-order"
                        onClick={this.sendForm}
                        disabled={!model.isValid}
                    >
                        {this.l10n('PBP_ENTITY_MODAL_BTN')}
                    </button>
                </div>
            </>
        ),
        success = (
            <>
                    <Control className={'success'}>
                        <div className='success-title' dangerouslySetInnerHTML={{__html: this.l10n(!isExpressEnergy ? 'PBP_ENTITY_ORDER_MODAL_SUCCESS_TITLE_1' : 'PBP_ENTITY_ORDER_MODAL_SUCCESS_TITLE_2')}}></div>
                        <div className='success-text' dangerouslySetInnerHTML={{__html: this.l10n(!isExpressEnergy ? 'PBP_ENTITY_ORDER_MODAL_SUCCESS_TEXT_1' : 'PBP_ENTITY_ORDER_MODAL_SUCCESS_TEXT_2')}}></div>
                        <button className='success-btn' onClick={() => this.closeModal()}>{this.l10n('CLOSE_FORM_3')}</button>
                    </Control>
            </>
        ),
        error = (
            <Control className="control" style={{marginTop: '30px'}}>
                <ErrorComponent type="form">
                    {this.l10n('GREEN_CARD_ORDER_ERROR_TEXT')}
                </ErrorComponent>
            </Control>
        ),
        screens = {
            form,
            success,
            error,
        };

    return (
        <div className="form-wrapper" onClick={this.closeModal}>
            <div className="form-contain">
                <div className="close-btn" onClick={() => this.closeModal()} onKeyDown={(e) => e.key === 'Enter' && this.closeModal()} tabIndex="0"/>
                {screens[this.state.activeScreen]}
            </div>
        </div>
    );
}
